import { cloneHash } from './helpers';
import { CardItem } from '../types';
import { getBossMintPda } from './pda';

import {
  bossTier2CollectImg, bossTier2AirImg, bossTier2PowerImg, bossTier2YieldImg, bossTier2JackpotImg,
  bossTier3CollectImg, bossTier3AirImg, bossTier3PowerImg, bossTier3YieldImg, bossTier3JackpotImg,
  bossTier4CollectImg, bossTier4AirImg, bossTier4PowerImg, bossTier4YieldImg, bossTier4JackpotImg,
  bossTier5CollectImg, bossTier5AirImg, bossTier5PowerImg, bossTier5YieldImg, bossTier5JackpotImg,
  bossTier6CollectImg, bossTier6AirImg, bossTier6PowerImg, bossTier6YieldImg, bossTier6JackpotImg,
  bossTier7CollectImg, bossTier7AirImg, bossTier7PowerImg, bossTier7YieldImg, bossTier7JackpotImg,
} from './bossImg';

// Card item with mint address getter
export interface CardItemWithMint extends CardItem {
  getMint: () => import('@solana/web3.js').PublicKey;
}

// Create card with mint getter
function createCard(
  name: string,
  cat: number,
  tier: number,
  desc: string,
  img?: string,
  force?: number
): CardItemWithMint {
  return {
    name,
    cat,
    tier,
    desc,
    img,
    force,
    getMint: () => getBossMintPda(tier, cat)[0],
  };
}

export const cardsLib: CardItemWithMint[] = [
  // Tier 1 - Grunt (not a boss, but ERC20-like token)
  createCard(
    "Grunt",
    1, 1,
    "This token is not NFT, but an upgradable material to mint next level NFT's. To mint one unit of higher level NFT, four units of the previous level are consumed."
  ),

  // Tier 2 - Basic Boss
  createCard("Basic Boss — Collectable", 1, 2, "Collect these NFT's or use them in claimable events", bossTier2CollectImg),
  createCard("Basic Boss — Airdrop", 2, 2, "Allows owner to claim fixed amount of YEAR tokens on a daily basis", bossTier2AirImg, 0.1),
  createCard("Basic Boss — Power", 3, 2, "Owner may stake this NFT to get a share of 0.8 YEAR/block reward", bossTier2PowerImg, 1),
  createCard("Basic Boss — Yield", 4, 2, "Increases the amount of multiple played games by 1", bossTier2YieldImg),
  createCard("Basic Boss — Jackpot", 5, 2, "Allows a player to invoke a Jackpot in Level 1 (NFT gets consumed)", bossTier2JackpotImg),

  // Tier 3 - Medium Boss
  createCard("Medium Boss — Collectable", 1, 3, "Collect these NFT's or use them in claimable events", bossTier3CollectImg),
  createCard("Medium Boss — Airdrop", 2, 3, "Allows owner to claim fixed amount of YEAR tokens on a daily basis", bossTier3AirImg, 0.6),
  createCard("Medium Boss — Power", 3, 3, "Owner may stake this NFT to get a share of 0.8 YEAR/block reward", bossTier3PowerImg, 5),
  createCard("Medium Boss — Yield", 4, 3, "Increases the amount of multiple played games by 5", bossTier3YieldImg),
  createCard("Medium Boss — Jackpot", 5, 3, "Allows a player to invoke a Jackpot in Level 2 (NFT gets consumed)", bossTier3JackpotImg),

  // Tier 4 - Strong Boss
  createCard("Strong Boss — Collectable", 1, 4, "Collect these NFT's or use them in claimable events", bossTier4CollectImg),
  createCard("Strong Boss — Airdrop", 2, 4, "Allows owner to claim fixed amount of YEAR tokens on a daily basis", bossTier4AirImg, 3.2),
  createCard("Strong Boss — Power", 3, 4, "Owner may stake this NFT to get a share of 0.8 YEAR/block reward", bossTier4PowerImg, 25),
  createCard("Strong Boss — Yield", 4, 4, "Increases the amount of multiple played games by 25", bossTier4YieldImg),
  createCard("Strong Boss — Jackpot", 5, 4, "Allows a player to invoke a Jackpot in Level 3 (NFT gets consumed)", bossTier4JackpotImg),

  // Tier 5 - Epic Boss
  createCard("Epic Boss — Collectable", 1, 5, "Collect these NFT's or use them in claimable events", bossTier5CollectImg),
  createCard("Epic Boss — Airdrop", 2, 5, "Allows owner to claim fixed amount of YEAR tokens on a daily basis", bossTier5AirImg, 16),
  createCard("Epic Boss — Power", 3, 5, "Owner may stake this NFT to get a share of 0.8 YEAR/block reward", bossTier5PowerImg, 125),
  createCard("Epic Boss — Yield", 4, 5, "Increases the amount of multiple played games by 125", bossTier5YieldImg),
  createCard("Epic Boss — Jackpot", 5, 5, "Consume to receive 1 random Boss at Tier 6", bossTier5JackpotImg),

  // Tier 6 - Legendary Boss
  createCard("Legendary Boss — Collectable", 1, 6, "Collect these NFT's or use them in claimable events", bossTier6CollectImg),
  createCard("Legendary Boss — Airdrop", 2, 6, "Allows owner to claim fixed amount of YEAR tokens on a daily basis", bossTier6AirImg, 76.8),
  createCard("Legendary Boss — Power", 3, 6, "Owner may stake this NFT to get a share of 0.8 YEAR/block reward", bossTier6PowerImg, 625),
  createCard("Legendary Boss — Yield", 4, 6, "Increases the amount of multiple played games by 625", bossTier6YieldImg),
  createCard("Legendary Boss — Jackpot", 5, 6, "Consume to receive 1 random Boss at Tier 7", bossTier6JackpotImg),

  // Tier 7 - Ultimate Boss
  createCard("Ultimate Boss — Collectable", 1, 7, "Collect these NFT's or use them in claimable events", bossTier7CollectImg),
  createCard("Ultimate Boss — Airdrop", 2, 7, "Allows owner to claim fixed amount of YEAR tokens on a daily basis", bossTier7AirImg, 358.4),
  createCard("Ultimate Boss — Power", 3, 7, "Owner may stake this NFT to get a share of 0.8 YEAR/block reward", bossTier7PowerImg, 3125),
  createCard("Ultimate Boss — Yield", 4, 7, "Increases the amount of multiple played games by 3125", bossTier7YieldImg),
  createCard("Ultimate Boss — Jackpot", 5, 7, "Consume to receive 4 random Bosses at Tier 7", bossTier7JackpotImg),
];

export function getCardsLibCategory(category: number): CardItemWithMint[] {
  const cardsLibMod: CardItemWithMint[] = [];
  cardsLib.forEach((card) => {
    if (category === card.cat) {
      cardsLibMod.push({ ...card });
    }
  });
  return cardsLibMod;
}

export function getCardsLibTier(tier: number): CardItemWithMint[] {
  const cardsLibMod: CardItemWithMint[] = [];
  cardsLib.forEach((card) => {
    if (tier === card.tier) {
      cardsLibMod.push({ ...card });
    }
  });
  return cardsLibMod;
}

export function getCardsLibNFT(): CardItemWithMint[] {
  const cardsLibMod: CardItemWithMint[] = [];
  cardsLib.forEach((card) => {
    if (card.tier !== 1) {
      cardsLibMod.push({ ...card });
    }
  });
  return cardsLibMod;
}

// Get card by tier and category
export function getCard(tier: number, category: number): CardItemWithMint | undefined {
  return cardsLib.find(card => card.tier === tier && card.cat === category);
}
